const initialState = () => ({
  isOpened: false,
  loading: false,
  error: null,
  data: {}
});

const ACTION_KEY = 'TELESERVICE_PEP_MODAL';

const reducer = (state = initialState(), reduxAction) => {
  switch (reduxAction.type) {
    case `${ACTION_KEY}_OPEN`: {
      const { data } = reduxAction.payload;
      return {
        ...state,
        data,
        isOpened: true
      };
    }
    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }

    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: reduxAction.payload,
        data: {}
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      const { payload } = reduxAction;
      return {
        ...state,
        error: null,
        loading: false,
        data: payload
      };
    }
    case `${ACTION_KEY}_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
